export function assertUnreachable(value: never): never {
  throw new TypeError(
    `This code should never be executed, its shows we have an unhandled case for the value ${value}`,
  );
}
